import React, { useState } from 'react';

const MatchTracker = ({ item }) => {
  const [activeLoder, setActiveLoader] = useState(true);
  const [height] = useState(window.innerWidth * 0.659 + 39);

  const onLoadIframe = () => {
    window.addEventListener('message', ({ data }) => {
      if (data.type === 'applicationReady') {
        setActiveLoader(false);
      }
    });
  };

  return (
    <div className="match_tracker" style={{ clear: 'both', height: height }}>
      <iframe
        height={height}
        onLoad={onLoadIframe}
        scrolling="no"
        frameBorder="0"
        src={`https://animations.betcoapps.com/#/widget/animation?${item.betbleUri}&amp;lang=kor`}
      ></iframe>
      <p className="tip">데이터 반영에 차이가 있을 수 있습니다.</p>
    </div>
  );
};

export default MatchTracker;
